import { tickerItems } from "@/mocks/kanliao";

export default function Ticker() {
  const row = [...tickerItems, ...tickerItems];
  return (
    <div className="relative z-50 overflow-hidden border-b border-primary-800 bg-primary-600">
      <div className="flex w-max items-center ticker-track">
        {row.map((t, i) => (
          <span
            key={i}
            className="flex items-center whitespace-nowrap px-6 py-2 text-[13px] text-background-50/95"
          >
            <i className="ri-fire-line mr-2 text-accent-400" />
            {t}
            <i className="ri-arrow-right-up-line ml-6 text-background-50/50" />
          </span>
        ))}
      </div>
      <span className="pointer-events-none absolute right-0 top-0 flex h-full items-center gap-1.5 bg-primary-600 px-3 text-[12px] font-semibold text-background-50">
        速递 LIVE
        <span className="h-1.5 w-1.5 rounded-full bg-accent-400" />
      </span>
    </div>
  );
}